import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { DemoProvider } from "@/context/DemoContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import DealDatabase from "@/pages/DealDatabase";
import DealDetail from "@/pages/DealDetail";
import Pipeline from "@/pages/Pipeline";
import MapView from "@/pages/MapView";
import FinderAste from "@/pages/FinderAste";
import AstaDettaglio from "@/pages/AstaDettaglio";
import LeMieAste from "@/pages/LeMieAste";
import Operatori from "@/pages/Operatori";
import Ingestion from "@/pages/Ingestion";
import Settings from "@/pages/Settings";
import WalletPage from "@/pages/WalletPage";
import AdminPanel from "@/pages/AdminPanel";
import DataRoom from "@/pages/DataRoom";
import DataRoomDetail from "@/pages/DataRoomDetail";
import Manuale from "@/pages/Manuale";
import { Toaster } from "@/components/ui/sonner";

function App() {
  useEffect(() => {
    document.title = "Rebreton | Beta Aste";
  }, []);
  return (
    <div className="App">
      <AuthProvider>
        <DemoProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/recupera-password" element={<ResetPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/operazioni" element={<DealDatabase />} />
              <Route path="/operazioni/:id" element={<DealDetail />} />
              <Route path="/pipeline" element={<Pipeline />} />
              <Route path="/mappa" element={<MapView />} />
              <Route path="/finder-aste" element={<FinderAste />} />
              <Route path="/finder-aste/preferiti" element={<LeMieAste />} />
              <Route path="/finder-aste/:idAnnuncio" element={<AstaDettaglio />} />
              <Route path="/operatori" element={<Operatori />} />
              <Route path="/wallet" element={<WalletPage />} />
              <Route path="/dataroom" element={<DataRoom />} />
              <Route path="/dataroom/:id" element={<DataRoomDetail />} />
              <Route path="/fonti" element={<Ingestion />} />
              <Route path="/manuale" element={<Manuale />} />
              <Route path="/impostazioni" element={<Settings />} />
              <Route path="/amministrazione" element={<AdminPanel />} />
            </Route>
          </Routes>
        </BrowserRouter>
        </DemoProvider>
        <Toaster position="top-right" theme="dark" />
      </AuthProvider>
    </div>
  );
}

export default App;
